import react from 'react';
import { DataState } from '../interfaces/commonInterfaces';

 export function GetCotizacion(dataCotizador: DataState) : any {
    if(dataCotizador.plazo != undefined){
        const gracePerio = dataCotizador.plazo -1
    }
    const fechaHoy: Date = new Date();
     if(dataCotizador.productTypeOption == 0){
        //Cédito Simple
        return new Promise((resolve, reject) => {
            fetch(`https://finbe-gateway-api-stge.herokuapp.com/quotation/api/v1/credit-amortizations/unspent-balances`,
            {
                method: "POST",
                body: JSON.stringify({
                    "downpayment_deposit_percentage": 0,
                    "credit_total":  Number(dataCotizador.credit),
                    "credit_length_in_months":  Number(dataCotizador.plazo),
                    "credit_start_date": fechaHoy,
                    "grace_periods": 0,
                    "grace_period_start_date": "",
                    "yearly_rate": Number(dataCotizador.tasa),
                    "interest_iva": 16,
                    "include_administration_cost": false,
            }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'e6779c784d207cda:836176488fea515c'
                  },
            })
            .then(response => response.json())
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    }
    else{
        return new Promise((resolve, reject) => {
            //Cédito Revolvente
            fetch(`https://finbe-gateway-api-stge.herokuapp.com/quotation/api/v1/credit-amortizations/unspent-balances`,
            {
                method: "POST",
                body: JSON.stringify({
                        "downpayment_deposit_percentage": 0,
                        "credit_total":  Number(dataCotizador.credit),
                        "credit_length_in_months":  Number(dataCotizador.plazo),
                        "credit_start_date": fechaHoy,
                        "grace_periods": Number(dataCotizador.plazo -1),
                        "grace_period_start_date": "",
                        "yearly_rate": Number(dataCotizador.tasa),
                        "interest_iva": 16,
                        "include_administration_cost": false,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'e6779c784d207cda:836176488fea515c'
                  },
            })
            .then(response => response.json())
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    }
}
